<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-education-experience`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.106 27.17a1 1 0 011.341-.446l2 1a1 1 0 01.553.894v6.187l11 5.923 11-5.923v-6.187a1 1 0 01.553-.894l2-1a1 1 0 011.447.894V36a2 2 0 01-1.052 1.76l-13 7a2 2 0 01-1.896 0l-13-7A2 2 0 019 36v-8.382a1 1 0 01.106-.447zM25.415 4.26l.226.093 18 8.095c1.534.69 2.324 2.113 2.358 3.554L46 16v19a1 1 0 01-1 1h-2a1 1 0 01-1-1V20.557l-16.226 8.028a4 4 0 01-3.336.098l-.212-.098-18-8.905c-2.966-1.467-2.951-5.666-.055-7.142l.188-.09 18-8.096a4 4 0 013.056-.093zM24 8L6 16.095 24 25l18-8.905L24 8z"/></svg>
</template>
<script>

export default {
  name: 'IconEducationExperience',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
